// packages/web/src/components/AccountEntry.tsx — the persistent, quiet
// shell-level entry point into the Account screen (Core hardening
// 2026-07-29: there was no sign-out path anywhere in this app — this is
// its front door).
//
// Two placements, one button (S6, Huan's browser walk 2026-08-11):
//   - 'floating' (the phone/bottom-nav shell): the original pinned corner
//     affordance, mirroring GlobalCreate.tsx's pattern — unchanged.
//   - 'rail': rendered INSIDE the SideRail's own layout at its foot, in the
//     rail items' own quiet voice — no longer floating over the rail's head.
import './AccountEntry.css';

export interface AccountEntryProps {
  onNavigate: () => void;
  variant?: 'floating' | 'rail';
}

export function AccountEntry({ onNavigate, variant = 'floating' }: AccountEntryProps) {
  return (
    <button
      type="button"
      class={variant === 'rail' ? 'account-entry account-entry--rail' : 'account-entry'}
      onClick={onNavigate}
      aria-label="Account"
      data-testid="account-entry"
    >
      <span aria-hidden="true">⚙</span>
    </button>
  );
}
